// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class ActingProfile extends TrackingModel {
	public ActingProfileId: number = 0;
	public ResourceId: number = 0;
	public GenderId?: number;
	public Name: string = "";
	public Description?: string;
	public Pitch?: string;
	public AgeRangeYearsLower?: number;
	public AgeRangeYearsUpper?: number;
	public AvatarBlobPath?: string;
}